import { usePageContext } from 'hooks/context';
import { Locale } from 'utils/locale';

/**
 * Get the current locale
 *
 * @deprecated Use `useClientContext().lang` instead
 */
export function useLocale(): Locale {
  const context = usePageContext();
  return new Locale(context.route.locale);
}
